import { KycProvider, useSmartWallet } from '@package/smart-wallet/providers';
import { Navigate, Outlet } from 'react-router-dom';

export const ProtectedRoutes = () => {
  const { isLoggedIn } = useSmartWallet();
  return (
    <KycProvider>{isLoggedIn ? <Outlet /> : <Navigate to='/' />}</KycProvider>
  );
};
